import React, { useState } from 'react';
import ConfirmMailModal from './ChangePsswordModal';
import { useNavigate } from 'react-router-dom';
import { Lock, User, Pill, Eye, EyeOff } from 'lucide-react';
import { validateChangePassword } from '../../Services/loadOrder';
import logo from '../../assets/images/logo-win-white.svg';
import '../../assets/css/login.css';
import toast, { Toaster } from 'react-hot-toast';

const ChangePassword = () => {
  const navigate = useNavigate();
  const [userId, setUserId] = useState('');
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [pharmacyID, setPharmacyId] = useState('');
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleSubmit = () => {
    if (!userId || !oldPassword || !newPassword || !pharmacyID) {
      toast.error('Please fill in all fields.');
      return;
    }

    validateChangePassword(userId, oldPassword, newPassword, pharmacyID)
      .then(response => {
        if (response.success) {
          toast.success('Password changed successfully.');
          setShowModal(true);
        } else {
          toast.error('Invalid credentials or server error.');
        }
      })
      .catch(error => {
        console.error('Error during password change:', error);
        toast.error('Failed to change password. Please try again.');
      });
  };

  return (
    <div className="body-style">
      <Toaster position="top-right" />
      <div className="login-page">
        <header className="top-logo">
          <img src={logo} alt="Logo" />
        </header>

        <div className="login-container full-width">
          <div className="login-form" style={{ textAlign: 'center' }}>
            <h1 style={{ marginBottom: '20px', fontWeight: '600' }}>Change Password</h1>

            {/* User ID Field */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <div style={{ padding: '10px' }}>
                <User color="#ec088c" />
              </div>
              <input
                type="text"
                placeholder="Enter User ID"
                value={userId}
                onChange={(e) => setUserId(e.target.value)}
                style={{
                  height: '32px',
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  outline: 'none',
                }}
              />
            </div>

            {/* Old Password Field */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px', position: 'relative' }}>
              <div style={{ padding: '10px' }}>
                <Lock color="#ec088c" />
              </div>
              <input
                type={showOldPassword ? "text" : "password"}
                placeholder="Enter Old Password"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
                style={{
                  height: '32px',
                  width: '100%',
                  padding: '10px 38px 10px 10px',
                  border: '1px solid #ccc',
                  outline: 'none',
                }}
              />
              <span
                onClick={() => setShowOldPassword((prev) => !prev)}
                style={{
                  position: 'absolute',
                  right: '18px',
                  top: '40%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#888',
                  zIndex: 2,
                }}
                tabIndex={0}
                role="button"
                aria-label={showOldPassword ? "Hide old password" : "Show old password"}
              >
                {showOldPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </span>
            </div>

            {/* New Password Field */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px', position: 'relative' }}>
              <div style={{ padding: '10px' }}>
                <Lock color="#ec088c" />
              </div>
              <input
                type={showNewPassword ? "text" : "password"}
                placeholder="Enter New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                style={{
                  height: '32px',
                  width: '100%',
                  padding: '10px 38px 10px 10px',
                  border: '1px solid #ccc',
                  outline: 'none',
                }}
              />
              <span
                onClick={() => setShowNewPassword((prev) => !prev)}
                style={{
                  position: 'absolute',
                  right: '18px',
                  top: '40%',
                  transform: 'translateY(-50%)',
                  cursor: 'pointer',
                  color: '#888',
                  zIndex: 2,
                }}
                tabIndex={0}
                role="button"
                aria-label={showNewPassword ? "Hide new password" : "Show new password"}
              >
                {showNewPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </span>
            </div>
            
            {/* Pharmacy field */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
              <div style={{ padding: '10px' }}>
                <Pill color="#ec088c" />
              </div>
              <input
                type="text"
                placeholder="Enter Pharmacy ID"
                value={pharmacyID}
                onChange={(e) => setPharmacyId(e.target.value)}
                style={{
                  height: '32px',
                  width: '100%',
                  padding: '10px',
                  border: '1px solid #ccc',
                  outline: 'none',
                }}
              />
            </div>

            <button
              onClick={handleSubmit}
              style={{
                marginTop: '10px',
                padding: '8px 20px',
                backgroundColor: '#ec088c',
                border: '1px solid #ccc',
                borderRadius: '4px',
                cursor: 'pointer',
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
      <ConfirmMailModal
        open={showModal}
        disableConfirm={false}
      />
    </div>
  );
};

export default ChangePassword;
